import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const RedoIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 9H9C6.239 9 4 11.239 4 14C4 16.761 6.239 19 9 19H12M20 9L16 5M20 9L16 13"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

RedoIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(RedoIcon);
